<template>
  <div class="download-wrapper">
    <div class="download-title">
      {{ $t('common.downloadAnty') }}
    </div>
    <div class="download-subtitle">
      {{ $t('common.downloadAntySubtitle') }}
    </div>
    <v-btn color="primary" block @click="handleClick">
      {{ $t('common.download') }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'DownloadSection',

  methods: {
    handleClick () {
      let localPath
      if (this.$i18n.locale === 'cn' || this.$i18n.locale === 'es') {
        localPath = 'en'
      } else {
        localPath = this.$i18n.locale
      }

      location.href = `${process.env.VUE_APP_BASE_LANDING_URL}${localPath}/download/`
    }
  }
}
</script>

<style scoped>
  .download-wrapper {
    background-color: #F7F7F7;
    width: 238px;
    padding: 16px;
    border-radius: 16px;
    color: #757575;
  }
  .download-title {
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin-bottom: 4px;
  }
  .download-subtitle {
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    color: #ACACAC;
    margin-bottom: 16px;
  }
</style>
